export default __webpack_public_path__ + "static/media/1366.e219bf4f.png";